import { Layer } from '@deck.gl/core';
import { LineLayer } from '@deck.gl/layers';
import { IFlightItem } from '../flights/types';
import { DeckLayerCreator } from './deck-layer-creator';
import { DeckOverlayPlugin } from './deck-overlay-plugin';
import { AnimatedLineLayer } from './layers/line/animated-line-layer';

export class DeckDiversions extends DeckLayerCreator {
    constructor(plugin: DeckOverlayPlugin) {
        super(plugin);
    }

    createLayers(data: IFlightItem[]): Layer[] {
        if (!this.props?.flights.active.visible || !this.props.flights.active.showDiversions) {
            return [];
        }

        const { diversionLineNewColor, diversionLineOldColor } = this.props.flights.active;
        const diversionLayerProps: Partial<AnimatedLineLayer<IFlightItem>['props']> = {
            data,
            getWidth: 2,
            wrapLongitude: true,
            getSourcePosition: (d) => this.getFlightPosition(d),
            getIsHidden: (d) => this.getIsHidden(d),
            getId: (d) => d.id,
            updateTriggers: {
                all: [this.flightsVersion],
                getSourcePosition: this.getPositionUpdateTrigger,
                getIsHidden: this.getIsHiddenUpdateTrigger
            },
            positionTexture: this.plugin.positionTexture,
            parameters: this.plugin.getRenderingParams()
        };

        // Diverting from
        const oldDiversionLineProps: Partial<AnimatedLineLayer<IFlightItem>['props']> = {
            ...diversionLayerProps,
            id: 'diversion-line-old',
            getColor: diversionLineOldColor,
            getTargetPosition: (d) => d.oldDestinationPosition!
        };

        // Diverting to
        const newDiversionLineProps: Partial<AnimatedLineLayer<IFlightItem>['props']> = {
            ...diversionLayerProps,
            id: 'diversion-line-new',
            getColor: diversionLineNewColor,
            getTargetPosition: (d) => d.destinationPosition!
        };

        const newDiversionLayer = this.isCoastMode
            ? new AnimatedLineLayer({ ...newDiversionLineProps, id: 'diversion-line-new-animated' })
            : new LineLayer<IFlightItem>(newDiversionLineProps);

        const oldDiversionLayer = this.isCoastMode
            ? new AnimatedLineLayer({ ...oldDiversionLineProps, id: 'diversion-line-old-animated' })
            : new LineLayer<IFlightItem>(oldDiversionLineProps);

        return [newDiversionLayer, oldDiversionLayer];
    }
}
